import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from 'store/actions/tripDetails';
import { TripDetailsState } from 'store/types/tripDetails';

const initialState: TripDetailsState = {
  departureTrip: null,
  returnTrip: null,
};

export const tripDetailsReducer = createReducer<TripDetailsState, ActionType<typeof actions>>(initialState)
  .handleAction(actions.setAvailableTrips, (state, { payload }) => ({
    ...state,
    departureTrip: payload.departureTrip,
    returnTrip: payload.returnTrip,
  }))
  .handleAction(actions.clearAvailableTrips, (state) => ({
    ...state,
    departureTrip: null,
    returnTrip: null,
  }));
